// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"447":"6ef8e59a","551":"7e520f0e","994":"96d9bb23"}[chunkId] + ".css";
};